import React from "react";
import photo1 from "../testimonials-photos/testimonial-man1.jpg"
import photo2 from "../testimonials-photos/testimonial-man2.jpg"
import photo3 from "../testimonials-photos/testimonial-man3.jpg"
import photo4 from "../testimonials-photos/testimonial-man4.jpg"
import photo5 from "../testimonials-photos/testimonial-man5.jpg"

export default
 [
  {
    image: photo1,
    review: "FitFlex changed my life! Their personalized workouts and supportive community helped me achieve incredible results. I'm now stronger, healthier, and more confident than ever. Thanks, FitFlex!",
    name: 'ANAS MAJID',
    status : 'ENTREPRENEUR'
  },
  {
    image: photo2,
    review: "As a coach, I prioritize helping others reach their fitness goals, but being a part of FitFlex allowed me to focus on myself too. The tailored workouts and top-notch facilities pushed me beyond my limits, transforming my body and boosting my confidence.",
    name: 'ABRAR NAZIR',
    status: 'COACH'
  },
  {
    image : photo3,
    review:"FitFlex has been the catalyst for an incredible body transformation journey. As an engineer with a busy schedule, I struggled to find time for fitness. FitFlex's flexible class timings and efficient workout plans made it possible for me to stay committed and consistent.",
    name: 'ZEESHAN HASHMI',
    status: "ENGINEER"
  },
  {
    image : photo4,
    review: 'FitFlex has been a blessing for me as an aged father. Their gentle and caring approach, tailored specifically for my needs. With their guidance and the support of the FitFlex community, I feel healthier, more active, and happier than ever before.',
    name: 'HUZAIF MALIK',
    status: "47-YEAR OLD: FATHER"
  },
  {
    image : photo5,
    review:"FitFlex has been my fitness sanctuary! As a young youth, I was determined to transform my body and push my limits. FitFlex's dynamic workouts, motivating trainers, and vibrant atmosphere kept me motivated and excited for every session",
    name: 'HARIS MANAZIR',
    status: "ASPIRANT"
  }
];
